module.exports = "pegasus/assets/blocks/column-4-theme6.png";